<template>
  <div class="main-content">
    <div class="detail-table">
      <div class="form-group">
        <label>University</label>
        <div>{{ template.university.name }}</div>
      </div>
      <div class="form-group">
        <label>Mail Template Name</label>
        <div>{{ template.name }}</div>
      </div>
      <div class="form-group">
        <label>Target</label>
        <div>{{ template.target | target }}</div>
      </div>
      <div class="form-group">
        <label>Notification</label>
        <div>{{ template.notification | notification }}</div>
      </div>
      <div class="form-group">
        <label>Month</label>
        <div>{{ template.month }}</div>
      </div>
      <div class="form-group">
        <label>Subject</label>
        <div>{{ template.subject }}</div>
      </div>
      <div class="form-group">
        <label>Text</label>
        <div>{{ template.body }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  MailNotifications,
  mailNotificationType,
  MailTargets,
  mailTargetType,
} from '@/store/mails/types'
import { MailTemplate } from '@/store/mails/templates/types'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  filters: {
    target: (type: mailTargetType) => MailTargets[type],
    notification: (type: mailNotificationType) => MailNotifications[type],
  },
})
export default class MailTemplateDetailForm extends Vue {
  @Prop() template!: MailTemplate
}
</script>

<style scoped>
  .main-content {
    background: #fff;
    padding: 20px;
    border-radius: 20px;
    margin-bottom:20px;
  }

  .detail-table {
    width:100%;
  }

  .detail-table .detail-item-title {
    font-weight: bold;
    text-align: left;
    margin:10px 0;
  }

  .detail-table .detail-item {
    height:20px;
    margin-bottom: 20px;
    margin-left: 10px;
    font-size: 16px;
  }
</style>
